module.exports = __webpack_public_path__ + "img/202601_02.b3a6ee57.png";